import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { FileTypeEnum } from '@repo/toolkit/types'
import { UploadIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TripFolderDocumentInput } from '../../../lib/types/models/trip-folder/trip-folder-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FILE_VALIDATION } from '../../../lib/utils/validations/file.validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledFileInput from '../../elements/inputs/controlled-file-input'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

const schema: ZodType<TripFolderDocumentInput> = z.object({
  name: createStringSchema('nom du document'),
  document: FILE_VALIDATION({ error: 'Télécharger le document' })
})

const CreateTripFolderDocumentForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<TripFolderDocumentInput>) => {
  const form = useForm<TripFolderDocumentInput>({
    defaultValues,
    mode: FORM_MODE,
    resolver: zodResolver(schema)
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-3', className)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} required type="text" label="Nom du document" />
                </FormControl>
              </FormItem>
            )}
          />

          <div className="flex flex-col gap-2">
            <Typography variant="tag">Télécharger le document *</Typography>
            <FormField
              control={form.control}
              name="document"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledFileInput
                      previewOnClick
                      icon={UploadIcon}
                      placeholder="Glisser-déposer ou parcourir"
                      types={[FileTypeEnum.IMAGE, FileTypeEnum.PDF]}
                      files={field?.value ? [field?.value] : undefined}
                      onFilesChange={(files) => {
                        const file = files.length === 0 ? null : files[0]
                        field.onChange(file)
                        if (file) {
                          form.setValue('name', file.name)
                        }
                      }}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}
export default CreateTripFolderDocumentForm
